/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {
  Feed,
  Grid,
  List,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment-timezone';
import { parseJSON } from '../utils/json';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import Timestamp from './Timestamp';

// Still needed for the module-level locale; the feed date renders through Timestamp.
moment.locale('en-gb');

class AddressSettingActivities extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    hasAccess: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    t: PropTypes.func,
  }
  keyToColumnName = (key) => {
    const { t } = this.props;
    switch (key) {
      case 'format':
        return '';
      default: {
        // translate address fields
        let name = _.startCase(key).split(' ').splice(0, 2).join(' ');
        name = name.split(' ');
        name = t(name[0]).concat(' ', name[1]);
        return name;
      }
    }
  }
  keyToName = (key) => {
    const { t } = this.props;
    switch (key) {
      case 'format':
        return t('Address format template');
      default:
        return _.startCase(key).split(' ')[2];
    }
  }
  renderActivityMessage = (activity) => {
    const activityBefore = parseJSON(activity.before);
    const activityAfter = parseJSON(activity.after);
    const afterKeys = Object.keys(activityAfter);
    const changes = [];
    afterKeys.forEach((element) => {
      const columnName = this.keyToColumnName(element);
      const keyName = this.keyToName(element);
      let message;
      let after = '';
      const before = activityBefore[element];
      if (activity.before) {
        after = activityAfter[element];
      }
      if (before === after) {
        return;
      }
      switch (keyName) {
        case 'Required':
          message = (
            <span>
              <span style={{ color: '#666' }}>{columnName} </span>
              <Trans ns={TRANSLATION_FILES.screens} components={{ underline: <u /> }}>is set as <u>{after ? 'required' : 'optional'}</u> field</Trans>
            </span>
          );
          break;
        case 'Enabled':
          message = (
            <span>
              <span style={{ color: '#666' }}>{columnName} </span>
              <Trans ns={TRANSLATION_FILES.screens} components={{ underline: <u /> }}>is <u>{after ? 'enabled' : 'disabled'}</u></Trans>
            </span>
          );
          break;
        default:
          break;
      }
      switch (element) {
        case 'format':
          if (!before) message = <span><span style={{ color: '#666' }}>{keyName}</span>: <u>{after}</u></span>;
          break;
        default:
          break;
      }
      if (message) {
        changes.push(message);
      } else if (before || after) {
        if (before === false && after) {
          message = (
            <Trans ns={TRANSLATION_FILES.screens}>
              <span><span style={{ color: '#666' }}>{columnName && <span>{{ columnName }}&apos;s </span>}{{ keyName }}</span> has been added</span>
            </Trans>
          );
        } else if (!before) {
          message = <span><span style={{ color: '#666' }}>{columnName ? `${columnName}'s ` : ''}{keyName}</span>: <u>{after}</u></span>;
        } else if (before && !after) {
          message = (
            <Trans ns={TRANSLATION_FILES.screens}>
              <span><span style={{ color: '#666' }}>{columnName && <span>{{ columnName }}&apos;s </span>}{{ keyName }}</span> has been removed</span>
            </Trans>
          );
        } else {
          message = (
            <Trans ns={TRANSLATION_FILES.screens}>
              <span><span style={{ color: '#666' }}>{columnName && <span>{{ columnName }}&apos;s </span>}{{ keyName }}</span> changed from <u>{{ before }}</u> to <u>{{ after }}</u></span>
            </Trans>
          );
        }
        changes.push(message);
      }
    });
    return (
      <List bulleted>
        {changes.map((element, id) => (
          <List.Item key={id}>
            {element}
          </List.Item>
        ))}
      </List>
    );
  };
  render() {
    const { data, t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Feed>
              { data && data.length > 0 ?
              data.map((activity, idx) => (
                <Feed.Event key={idx} className="activity-logs">
                  <Feed.Label icon="user" />
                  <Feed.Content>
                    <Feed.Date>
                      <Timestamp timestamp={activity.createdAt} format="MMMM Do YYYY, h:mm:ss a" />
                    </Feed.Date>
                    <Feed.Summary>
                      {this.props.hasAccess ?
                        activity.userAffiliateID > 0 ?
                          <Link to={`/users/${activity.userAffiliateID}/`}>
                            {activity.userPreferredName || t('Unknown')}
                          </Link>
                           : ''
                         : activity.userPreferredName
                      }
                      {` ${t(activity.message)}`}
                    </Feed.Summary>
                    <Feed.Extra text>
                      { activity.after && this.renderActivityMessage(activity) }
                    </Feed.Extra>
                  </Feed.Content>
                </Feed.Event>
              )) :
                this.props.loading ?
                  <br />
                : <center>{t('No activity found')}.</center>
              }
            </Feed>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
export default withTranslation(namespaces)(AddressSettingActivities);



// WEBPACK FOOTER //
// ./src/components/AddressSettingActivities.jsx